import { Routes, Route, Outlet, useLocation } from 'react-router-dom'

import Dashboard from 'pages/dashboard/view/Dashboard'
import SingleExpenseModal from './pages/expense/view/SingleExpenseModal'
import ClaimOverview from './pages/overview/view/ClaimOverview'
import AllReports from './pages/report/view/AllReports'
import SingleReport from './pages/report/view/SingleReport'

const ClaimRoutes = () => {
  let location = useLocation()
  let state = location.state
  return (
    <>
      <Routes>
        <Route index element={<ClaimOverview />} />
        <Route path="reports" element={<Outlet />}>
          <Route index element={<AllReports />} />
          <Route path=":reportId" element={<SingleReport />} />
        </Route>
        <Route path="allocation" element={<Dashboard />} />
      </Routes>
      {state?.backgroundLocation && (
        <Routes>
          <Route path="reports" element={<Outlet />}>
            <Route path=":reportId" element={<Outlet />}>
              <Route path="expense" element={<Outlet />}>
                <Route path=":id" element={<SingleExpenseModal data={state.data} />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      )}
    </>
  )
}

export default ClaimRoutes
